module.exports = __webpack_public_path__ + "static/media/bgi_d_salary_levels@3x.7dd69d93.png";